import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/api";

const inputCls =
  "w-full border-b border-black/20 bg-transparent py-3 text-base font-light text-[#131311] outline-none transition-colors placeholder:text-zinc-400 focus:border-[#9A7B24]";

export const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Your message is on its way");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="px-6 py-24 lg:py-36">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-xl"
      >
        <p className="text-center font-mono text-[10px] uppercase tracking-[0.5em] text-[#9A7B24]">Contact</p>
        <h2 className="font-display mt-4 text-center text-3xl font-light tracking-tight text-[#131311] sm:text-4xl lg:text-5xl">
          Private Inquiries
        </h2>
        <form onSubmit={submit} className="mt-12 flex flex-col gap-8">
          <input
            data-testid="contact-name-input"
            required
            maxLength={120}
            placeholder="Your name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={inputCls}
          />
          <input
            data-testid="contact-email-input"
            required
            type="email"
            placeholder="Your email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={inputCls}
          />
          <textarea
            data-testid="contact-message-input"
            required
            rows={4}
            maxLength={5000}
            placeholder="Your message"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className={`${inputCls} resize-none`}
          />
          <button
            data-testid="contact-submit-btn"
            type="submit"
            disabled={sending}
            className="group relative mx-auto mt-2 overflow-hidden rounded-full border border-[#B08D2E]/60 px-12 py-3.5 font-mono text-xs uppercase tracking-[0.3em] text-[#9A7B24] transition-colors duration-500 hover:text-white disabled:opacity-50"
          >
            <span className="absolute inset-0 -translate-x-full bg-[#B08D2E] transition-transform duration-500 ease-out group-hover:translate-x-0" />
            <span className="relative flex items-center gap-2">
              {sending && <Loader2 size={13} className="animate-spin" />}
              {sending ? "Sending…" : "Send Message"}
            </span>
          </button>
        </form>

      </motion.div>
    </section>
  );
};
